import { render, staticRenderFns } from "./SelectTratamiento.vue?vue&type=template&id=46743ba6"
import script from "./SelectTratamiento.vue?vue&type=script&lang=js"
export * from "./SelectTratamiento.vue?vue&type=script&lang=js"
import style0 from "./SelectTratamiento.vue?vue&type=style&index=0&id=46743ba6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports